import { combineReducers } from 'redux';

import checksSummaryReport from './checkssummaryreport/reducer';

export default combineReducers({
  checksSummaryReport,
});



// WEBPACK FOOTER //
// ./src/pages/checkssummaryreport/state/reducer.js